<div class="row">
    <div class="card-body prpl">
        <div class="row">

            <form autocomplete="off" class="p-0" novalidate [formGroup]="codeForm ">
                <div class="col-lg-12 col-md-12 prpl" *ngIf="key == 'blk'">
                    <div class="row clearfix ">
                        <div class="bc d-flex align-items-center pl-3 mb-1">
                            <img alt="Logo" src="../../assets/img/CollegeMaster.png" class="mh-40px pb-2">
                            <div class="ml-2">
                                <h3 class="main-content-label mb-1"><b>
                                        Add Block
                                    </b></h3>
                                <p class="text-muted card-sub-title mb-0">
                                    Add Block
                                </p>
                            </div>
                        </div>


                        <div class="col-sm-6">
                            <div class="form-group">
                                <div class="">
                                    <mat-form-field appearance="outline" class="example-full-width">
                                        <mat-label>Cg Name</mat-label>
                                        <input onkeydown="return (event.keyCode!=13);" matInput readonly
                                            formControlName="CgName">
                                    </mat-form-field>
                                </div>
                            </div>
                        </div>

                        <div class="col-sm-3">
                            <div class="form-group">
                                <div class="">
                                    <mat-form-field appearance="outline" class="example-full-width">
                                        <mat-label>Block Name</mat-label>
                                        <input onkeydown="return (event.keyCode!=13);" matInput
                                            formControlName="BlockName">
                                    </mat-form-field>
                                </div>
                            </div>
                        </div>

                        <div class="col-sm-3">
                            <div class="form-group">
                                <div class="">
                                    <mat-form-field appearance="outline" class="example-full-width">
                                        <mat-label>Block Capacity</mat-label>
                                        <input onkeydown="return (event.keyCode!=13);" matInput
                                            formControlName="BlockCapacity">
                                    </mat-form-field>
                                </div>
                            </div>
                        </div>


                        <div class="row prpl">
                            <div class="col-sm-12 ">

                                <button type="button" class="btn fr sz btn-primary btn-icon-text floatright mt-1"
                                    (click)="saveBlock()" *ngIf="submitButton">
                                    <span style="display: contents; align-items: center;">
                                        <img width="20vh" src="../../assets/img/save.gif" style="margin-right: 5px;">
                                        save
                                    </span>
                                </button>
                                <button id="Update" type="button" *ngIf="editButton && CodeUpdate"
                                    class="btn fr sz btn-primary btn-icon-text floatright mt-1" (click)="update()">
                                    <span style="display: contents; align-items: center;">
                                        <img width="20vh" src="../../assets/img/edit1.gif" style="margin-right: 5px;">
                                        Update
                                    </span>
                                </button>
                                <button id="Delete" type="button" *ngIf="deleteButton && CodeDelete"
                                    class="btn fr sz btn-primary btn-icon-text floatright mt-1"
                                    (click)="openConformationModalBox()">
                                    <span style="display: contents; align-items: center;">
                                        <img width="20vh" src="../../assets/img/trash.gif" style="margin-right: 5px;">
                                        {{ 'header.code-data.table.Delete' | translate }}
                                    </span>
                                </button>
                                <button id="Back" type="button" [mat-dialog-close]="true"
                                    class="btn btn-primary btn-icon-text floatright mr-3 mt-1">
                                    <span style="display: contents; align-items: center;">
                                        <img width="20vh" src="../../assets/img/turn-left.gif"
                                            style="margin-right: 7px;">
                                        {{'header.college-data.titleList.Back' |translate }}
                                    </span>
                                </button>
                            </div>
                        </div>
                    </div>
                    <hr *ngIf="showTable">
                    <div class="bc d-flex align-items-center pl-3" *ngIf="showTable">
                        <img alt="Logo" src="../../assets/img/CollegeMaster.png" class="mh-40px pb-2">
                        <div class="ml-2">
                            <h3 class="main-content-label mb-1"><b>
                                    Block Data
                                </b></h3>
                            <p class="text-muted card-sub-title mb-0">
                                Block Data
                            </p>
                        </div>
                    </div>
                    <hr *ngIf="showTable">
                    <div *ngIf="showTable" class="table-responsive table-container mt-4 pl-3">
                        <table class="table  table-bordered text-nowrap text-left">
                            <thead>
                                <tr class="text-left">
                                    <th class="f600"> Cg Code </th>
                                    <th class="f600"> Cg Name </th>
                                    <th class="f600"> Block Name
                                    </th>
                                    <th class="f600"> Block Capacity
                                    </th>
                                    <th>Action</th>
                                </tr>
                            </thead>
                            <tbody id="table_data">
                                <tr *ngFor="let item of blockData;">
                                    <td> {{item.CgCode}} </td>
                                    <td>{{item.CgName}} </td>
                                    <td> {{item.BlockName}} </td>
                                    <td>{{item.BlockCapacity}} </td>
                                    <td>
                                        <button (click)="edit(item)" class="btn btn-primary">
                                            <i class="fas fa-edit"></i>
                                        </button>
                                        <button (click)="remove(item)" class="btn btn-primary">
                                            <i class="fas fa-trash"></i>
                                        </button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                       
                    </div>
                </div>
                <div *ngIf="key == 'cap'">
                    <div class="row clearfix ">
                        <div class="bc d-flex align-items-center pl-3 mb-1">
                            <img alt="Logo" src="../../assets/img/CollegeMaster.png" class="mh-40px pb-2">
                            <div class="ml-2">
                                <h3 class="main-content-label mb-1"><b>
                                        Add Capacity
                                    </b></h3>
                                <p class="text-muted card-sub-title mb-0">
                                    Add Capacity
                                </p>
                            </div>
                        </div>


                        <div class="col-sm-6">
                            <div class="form-group">
                                <div class="">
                                    <mat-form-field appearance="outline" class="example-full-width">
                                        <mat-label>Cg Name</mat-label>
                                        <input onkeydown="return (event.keyCode!=13);" matInput readonly
                                            formControlName="CgName">
                                    </mat-form-field>
                                </div>
                            </div>
                        </div>

                        <div class="col-sm-6">
                            <div class="form-group">
                                <div class="">
                                    <mat-form-field appearance="outline" class="example-full-width">
                                        <mat-label>Capacity</mat-label>
                                        <input onkeydown="return (event.keyCode!=13);" matInput
                                            formControlName="Capacity">
                                    </mat-form-field>
                                </div>
                            </div>
                        </div>



                        <div class="row prpl">
                            <div class="col-sm-12 ">

                                <button type="button" class="btn fr sz btn-primary btn-icon-text floatright mt-1"
                                    (click)="saveCapacity()">
                                    <span style="display: contents; align-items: center;">
                                        <img width="20vh" src="../../assets/img/save.gif" style="margin-right: 5px;">
                                        Save
                                    </span>
                                </button>


                                <button id="Back" type="button" [mat-dialog-close]="true"
                                    class="btn btn-primary btn-icon-text floatright mr-3 mt-1">
                                    <span style="display: contents; align-items: center;">
                                        <img width="20vh" src="../../assets/img/turn-left.gif"
                                            style="margin-right: 7px;">
                                        {{'header.college-data.titleList.Back' |translate }}
                                    </span>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        </div>
    </div>
</div>